/**
 * Human-readable grouping label for a configurator section (PDF, emails, etc.).
 * Sanity `section` documents use `label` as the required display name; legacy
 * fields may still exist on some payloads.
 */
export function resolveSectionCategoryLabel(section: {
  label?: string | null
  id?: string | null
  categoryTitle?: string | null
  uiCategory?: string | null
  metadata?: Record<string, unknown> | null
}): string {
  const md = section.metadata
  const metaCategory =
    typeof md?.categoryTitle === "string" ? md.categoryTitle : undefined
  const metaUi =
    typeof md?.uiCategory === "string" ? md.uiCategory : undefined
  const candidates = [
    section.label,
    section.categoryTitle,
    metaCategory,
    section.uiCategory,
    metaUi,
    section.id,
  ]
  for (const c of candidates) {
    if (typeof c === "string" && c.trim() !== "") return c.trim()
  }
  return "Other"
}
